import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = environment.apiUrl;

  // Пропускаємо абсолютні URL та відносні від кореня (наприклад /api/...)
  const isApiRequest = !req.url.startsWith('http') && !req.url.startsWith('/');
  if (!isApiRequest) {
    return next(req);
  }

  const apiReq = req.clone({ url: `${apiUrl}/${req.url}` });
  return next(apiReq);
};

